import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook as fabFaFacebook,
  faXTwitter as fabFaXTwitter,
  faDiscord as fabFaDiscord,
  faSteam as fabFaSteam,
  faYoutube as fabFaYoutube,
  faInstagram as fabFaInstagram,
} from '@fortawesome/free-brands-svg-icons';

import 'Components/Account/AccountOverview/JoinCommunity.scss';

export default function JoinCommunity() {
  return (
    <div className="account-table">
      <div className="account-table-row">
        <div className="join-community-container">
          <div className="community-left-container">
            <div className="community-title">
              <FormattedMessage id="joincommunity.messageone" defaultMessage="Join Our Community Of Gamers" />
            </div>
            <div className="community-subtitle">
              <FormattedMessage id="joincommunity.messagetwo" defaultMessage="2 million strong and growing" />
            </div>
          </div>
          <div className="community-right-container">
            <div className="icons-container">
              <a href="https://www.facebook.com/wearefanatical" target="_blank" rel="noopener noreferrer nofollow" aria-label="Facebook" className="icon-container facebook">
                <FontAwesomeIcon icon={fabFaFacebook} title="Facebook" />
              </a>
              <a href="https://www.x.com/fanatical" target="_blank" rel="noopener noreferrer nofollow" aria-label="X" className="icon-container x">
                <FontAwesomeIcon icon={fabFaXTwitter} title="X" />
              </a>
              <a href="https://fant.cl/Discord" target="_blank" rel="noopener noreferrer nofollow" aria-label="Discord" className="icon-container discord">
                <FontAwesomeIcon icon={fabFaDiscord} title="Discord" />
              </a>
              <a href="https://steamcommunity.com/groups/wearefanatical" target="_blank" rel="noopener noreferrer nofollow" aria-label="Steam" className="icon-container steam">
                <FontAwesomeIcon icon={fabFaSteam} title="Steam" />
              </a>
              <a href="https://www.youtube.com/wearefanatical" target="_blank" rel="noopener noreferrer nofollow" aria-label="YouTube" className="icon-container youtube">
                <FontAwesomeIcon icon={fabFaYoutube} title="YouTube" />
              </a>
              <a href="https://www.instagram.com/wearefanatical/" target="_blank" rel="noopener noreferrer nofollow" aria-label="Instagram" className="icon-container instagram">
                <FontAwesomeIcon icon={fabFaInstagram} title="Instagram" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
